module.exports = __webpack_public_path__ + "static/img/qmwallet1-parnter_bg.3950be43.png";